import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { buildPageTitle } from '@/utils/buildPageTitle'

Vue.use(VueI18n)

export default ({ app, store, route }) => {
  app.i18n = new VueI18n({
    locale: store.state.language,
    fallbackLocale: 'en',
    messages: {
      it: require('@/static/locales/it.json'),
      de: require('@/static/locales/de.json'),
      fr: require('@/static/locales/fr.json'),
      pt: require('@/static/locales/pt.json'),
      en: require('@/static/locales/en.json'),
      es: require('@/static/locales/es.json'),
      he: require('@/static/locales/he.json')
    }
  })

  const recomputeTitle = () => {
    const title = buildPageTitle({
      store,
      i18n: app.i18n,
      query: (route && route.query) || {}
    })
    store.commit('setPageTitle', title)
  }

  // Ensure title is aligned with current locale and updates on language change.
  recomputeTitle()
  store.watch(
    (state) => state.language,
    () => recomputeTitle()
  )
}
